@if (Guides) {
<div class="shippingContainer">
  <div class="pdfContainer py-4">
    @for (doc of Guides; track doc) {
    <li>
      <img src="/icons/pdf-grey.svg" width="30px" class="mr-2" alt="file">
      <a [href]="documentUrlsMap[doc.code]" (mouseenter)="loadDocument(doc.code)"
        target=" _blank">{{doc.code}}&nbsp;&nbsp;{{doc.description}}</a>
    </li>
    }
  </div>
  <p>{{'common.text_Shipping_Packaging_content1'|cxTranslate}} <a
      href="mailto:cores@bendix.com">cores&#64;bendix.com</a>.
    {{'common.text_Shipping_Packaging_content2'|cxTranslate}}</p>
</div>
}